import { Link } from 'react-router-dom'
import { useTheme } from '../contexts/ThemeContext'
import 'primeicons/primeicons.css'

export default function CourseSection() {
  const { theme } = useTheme()

  return (
    <section className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-gray-200'}`}>
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Các Khóa Học Tại SaiGon FC
          </h2>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {/* Khóa Học Online */}
            <div className={`rounded-xl border ${theme === 'dark' ? 'border-gold-500/40 bg-black/60' : 'border-gold-400 bg-white'} p-6 md:p-8 shadow-lg ${theme === 'dark' ? 'shadow-gold-500/20' : 'shadow-gray-200'} hover:shadow-xl transition-all duration-300`}>
              <div className="flex flex-col h-full">
                {/* Icon */}
                <div className={`w-16 h-16 rounded-full bg-gold-gradient flex items-center justify-center mb-6 shadow-lg ${theme === 'dark' ? 'shadow-gold-500/30' : 'shadow-gold-400/40'}`}>
                  <i className="pi pi-video text-2xl text-black"></i>
                </div>

                {/* Title */}
                <h3 className={`text-xl md:text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                  Khóa Học Online
                </h3>

                {/* Description */}
                <p className={`text-sm md:text-base leading-relaxed mb-6 flex-grow ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                  Học bóng đá mọi lúc mọi nơi với các bài giảng chất lượng cao từ đội ngũ HLV chuyên nghiệp
                </p>

                {/* CTA Button */}
                <Link
                  to="/course/online"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gold-gradient text-white font-bold rounded-lg hover:shadow-lg hover:shadow-gold-500/50 transition transform hover:scale-105"
                >
                  <i className="pi pi-book"></i>
                  <span>Xem Khóa Học</span>
                </Link>
              </div>
            </div>

            {/* Khóa Học Cộng Đồng */}
            <div className={`rounded-xl border ${theme === 'dark' ? 'border-gold-500/40 bg-black/60' : 'border-gold-400 bg-white'} p-6 md:p-8 shadow-lg ${theme === 'dark' ? 'shadow-gold-500/20' : 'shadow-gray-200'} hover:shadow-xl transition-all duration-300`}>
              <div className="flex flex-col h-full">
                {/* Icon */}
                <div className={`w-16 h-16 rounded-full bg-gold-gradient flex items-center justify-center mb-6 shadow-lg ${theme === 'dark' ? 'shadow-gold-500/30' : 'shadow-gold-400/40'}`}>
                  <i className="pi pi-users text-2xl text-black"></i>
                </div>

                {/* Title */}
                <h3 className={`text-xl md:text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
                  Khóa Học Cộng Đồng
                </h3>

                {/* Description */}
                <p className={`text-sm md:text-base leading-relaxed mb-6 flex-grow ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                  Học bóng đá trực tiếp cùng cộng đồng với các buổi huấn luyện chất lượng cao từ đội ngũ HLV chuyên nghiệp
                </p>

                {/* CTA Button */}
                <Link
                  to="/classes"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gold-gradient text-white font-bold rounded-lg hover:shadow-lg hover:shadow-gold-500/50 transition transform hover:scale-105"
                >
                  <i className="pi pi-book"></i>
                  <span>Xem Khóa Học</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

